export const tratamientoRelacion = {
  id: null,
  code: '',
  code_parent: '',
  idmodelo_producto: null,
  idtipo_luna: null,
  idtratamiento: null,
  precio: null,
  posicion: null,
  show_precio: 1,
  // show_img_right: 0,
  show_icon_info: 0,
  precio_gratis_por_luz_azul: 0,
  // show_icon_after_nombre: 0,
  show_nombre_imagen: 0,
  idmodal: null,
  add_separador: 0,
  nombre_resaltado: 0,
  show_img: 0,
  page_titulo: '',
}